export const RangeInput = ({
	label,
	value,
	onChange,
	min = 0,
	max = 100,
	step = 1,
	disabled = false,
	className = "",
	showValue = false,
	valueFormatter = (val) => val,
}) => {
	const handleChange = (e) => {
		if (onChange) {
			onChange(parseFloat(e.target.value));
		}
	};

	// Calculate percentage
	const percentage = ((value - min) / (max - min)) * 100;

	const thumbSize = 16;

	return (
		<div className={`flex flex-col gap-2 w-full ${className}`}>
			{label && <label className="Subtitle2 text-color-Grey900">{label}</label>}
			<div className="flex items-center gap-3">
				<div className="relative w-full h-4 flex items-center rounded-full overflow-hidden">
					{/* Track background */}
					<div className="absolute w-full h-4 bg-[#F5F5F5] pointer-events-none" />
					{/* Filled track */}
					<div
						className="absolute h-4 bg-[#0060E5] pointer-events-none"
						style={{
							width: `calc(${percentage}% + ${thumbSize / 2 - (thumbSize * percentage) / 100}px)`,
						}}
					/>

					{/* Range input */}
					<input
						type="range"
						min={min}
						max={max}
						step={step}
						value={value}
						onChange={handleChange}
						disabled={disabled}
						className={`
              relative w-full h-4 bg-transparent appearance-none cursor-pointer z-10
              transition-opacity duration-200
              disabled:cursor-not-allowed
              [&::-webkit-slider-thumb]:appearance-none
              [&::-webkit-slider-thumb]:w-4
              [&::-webkit-slider-thumb]:h-4
              [&::-webkit-slider-thumb]:rounded-full
              [&::-webkit-slider-thumb]:bg-white
              [&::-webkit-slider-thumb]:border-2
              [&::-webkit-slider-thumb]:border-[#0060E5]
              [&::-webkit-slider-thumb]:cursor-pointer
              [&::-webkit-slider-thumb]:shadow-[0_1px_2px_-1px_rgba(0,0,0,0.1),0_1px_3px_0px_rgba(0,0,0,0.1)]
              [&::-webkit-slider-thumb]:transition-transform
              [&::-webkit-slider-thumb]:duration-150
              [&::-webkit-slider-thumb]:ease-in-out
              [&::-webkit-slider-thumb]:hover:scale-110
              [&::-webkit-slider-thumb]:active:scale-105
              [&::-webkit-slider-thumb]:disabled:bg-color-Grey300
              [&::-webkit-slider-thumb]:disabled:border-color-Grey300
              [&::-webkit-slider-thumb]:disabled:cursor-not-allowed
              [&::-moz-range-thumb]:w-4
              [&::-moz-range-thumb]:h-4
              [&::-moz-range-thumb]:rounded-full
              [&::-moz-range-thumb]:bg-white
              [&::-moz-range-thumb]:border-2
              [&::-moz-range-thumb]:border-[#0060E5]
              [&::-moz-range-thumb]:cursor-pointer
              [&::-moz-range-thumb]:shadow-[0_1px_2px_-1px_rgba(0,0,0,0.1),0_1px_3px_0px_rgba(0,0,0,0.1)]
              [&::-moz-range-thumb]:transition-transform
              [&::-moz-range-thumb]:duration-150
              [&::-moz-range-thumb]:ease-in-out
              [&::-moz-range-thumb]:hover:scale-110
              [&::-moz-range-thumb]:active:scale-105
              [&::-moz-range-thumb]:disabled:bg-color-Grey300
              [&::-moz-range-thumb]:disabled:border-color-Grey300
              [&::-moz-range-thumb]:disabled:cursor-not-allowed
              [&::-moz-range-track]:bg-transparent
              [&::-webkit-slider-runnable-track]:bg-transparent
            `}
					/>
				</div>
				{showValue && (
					<span className="Caption text-color-Grey500 min-w-[40px] text-right">
						{valueFormatter(value)}
					</span>
				)}
			</div>
		</div>
	);
};
